export const transferPLocks = (originalTrack, newTrack, originalPattern, newPattern) => {
    let originalSteps = originalPattern.getAllSteps();
    let newSteps = newPattern.getAllSteps();

    for (let i in originalSteps) {
        let originalStep = originalSteps[i];
        if (originalStep.pLockedParameters.length  === 0) {
            // then we don't care about this one
            continue;
        }
        // otherwise we have p-locks we need to transfer over
        let newStep = newSteps[i];
        for (let j in originalStep.pLockedParameters) {
            let originalParameter = originalStep.pLockedParameters[j];
            // we need to find the matcing parameter in this new track
            // we can match contexsts
            let newParameter = findMatchingParameter(originalParameter, newTrack);
            if (!newParameter) {
                // todo: need to actually delete that parameter
                delete originalParameter.stepToValue[originalStep.id];
                continue;
            }
            newParameter.stepToValue[newStep.id] = originalParameter.stepToValue[originalStep.id];
            delete originalParameter.stepToValue[newStep.id];
            delete newParameter.stepToValue[originalStep.id];

            // replace old parameter with new parameter
            newStep.pLockedParameters[j] = newParameter;
        }
    }
};

const findMatchingParameter = (parameter, track) => {
    let parameters = [
        ...track.getAllParameters(),
        ...track.sequencerEngine.lfos.flatMap(
            ({lfo}) => lfo.parameters)];

    return parameters
        .filter(p => { // first filter to match context
            if (!p.context) {
                // we can't do anything with this
                return false;
            }
            if (p.context.effect && parameter.context.effect) {
                return p.context.effect.name === parameter.context.effect.name;
            }
            if (p.context.midiEffect && parameter.context.midiEffect) {
                return p.context.midiEffect.name === parameter.context.midiEffect.name;
            }
            if (p.context.liveEffect && parameter.context.liveEffect) {
                return p.context.liveEffect.name === parameter.context.liveEffect.name;
            }
            if (p.context.instrument && parameter.context.instrument) {
                if (p.context.subDevice && parameter.context.subDevice) {
                    return p.context.subDevice.name === parameter.context.subDevice.name;
                }
            }
            if (p.context.lfoTrack && parameter.context.lfoTrack) {
                return p.context.lfoTrack.number === parameter.context.lfoTrack.number;
            }
            return false;
        })
        .find(p => // of these, we need to match the exact parameter
              p.name === parameter.name);
};
